<div class="container">
    <div style="text-align: center;">
        <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true" *ngIf="usuario==null"></span>
    </div>
    

    <div class="card shadow-lg border-0 rounded-lg mt-5" *ngIf="usuario!=null">
        <div class="card-header" style="color: teal;">
            <h3 class="text-center font-weight-light my-4">{{usuario.data().nombre}}</h3>
            <p>Id: {{usuario.id}}</p>
        </div>
        <div class="card-body">

            <div>
                <p>Seleccione una o varias de las opciones de autoridad:</p>
                <div>
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" id="defaultCheck1" [(ngModel)]="autoridadAislante" (change)="validaboton()">
                        <label class="form-check-label" for="defaultCheck1">Autoridad aislante</label>
                    </div>
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" id="defaultCheck2" [(ngModel)]="autoridadElectrica" (change)="validaboton()">
                        <label class="form-check-label" for="defaultCheck2">Autoridad aislante eléctrica</label>
                    </div>
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" id="defaultCheck3" [(ngModel)]="autoridadArea" (change)="validaboton()">
                        <label class="form-check-label" for="defaultCheck3">Autoridad de área</label>
                    </div>
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" id="defaultCheck4" [(ngModel)]="autoridadAreaLocal" (change)="validaboton()">
                        <label class="form-check-label" for="defaultCheck4">Autoridad de área local</label>
                    </div>
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" id="defaultCheck5" [(ngModel)]="autoridadHSE" (change)="validaboton()">
                        <label class="form-check-label" for="defaultCheck5">Autoridad HSE</label>
                    </div>
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" id="defaultCheck6" [(ngModel)]="gerenteRegional" (change)="validaboton()">
                        <label class="form-check-label" for="defaultCheck6">Gerente de campo</label>
                    </div>
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" id="defaultCheck7" [(ngModel)]="auditor" (change)="validaboton()">
                        <label class="form-check-label" for="defaultCheck7">Auditor</label>
                    </div>
                    
                    
  
                </div>
              </div>
            

            <ul class="list-group">
                <li class="list-group-item" *ngIf="procesodeEditarActivo">
                    <ngb-alert type="danger">
                        <strong>¿Guardar cambios?</strong>
                        <p><small>Confirme si quiere guardar los cambios</small></p>
                    </ngb-alert>
                    <div>
                        <button class="btn btn-primary" (click)="cancelaUpdate()" style="float: left; margin-left: 4px;">Cancelar</button>
                        <button class="btn btn-danger" (click)="update(usuario.id)" style="float: right; margin-right: 4px;">Guardar</button>
                    </div>
                </li>
                <li class="list-group-item" *ngIf="!procesodeEditarActivo">
                    <button class="btn btn-danger btn-block"  (click)="confirmaUpdate()">Guardar cambios</button>
                </li>

                <!-- <li class="list-group-item" *ngIf="procesodeEliminarActivo">
                    <ngb-alert type="danger">
                        <strong>¿Eliminar autoridad?</strong>
                        <p><small>Los datos del usuario se eliminarán</small></p>
                    </ngb-alert>
                    <div>
                        <p>
                            <ngb-alert [type]="tipodeAlerta" (close)="closeAlert()">{{ mensajeAlerta }} <span *ngIf="trabajando" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span></ngb-alert>
                        </p>
                        <button class="btn btn-primary" (click)="cancelarEliminar()" style="float: left; margin-left: 4px;">Cancelar</button>
                        <button class="btn btn-danger" (click)="eliminarCuenta(usuario.id)" style="float: right; margin-right: 4px;">Eliminar</button>
                    </div>
                </li>
                <li class="list-group-item" *ngIf="!procesodeEliminarActivo">
                    <button class="btn btn-danger btn-block"  (click)="confirmaEliminar()">Eliminar usuario</button>
                </li> -->
              </ul>
           
        </div>
        <div class="card-footer text-center">
           <button class="btn btn-primary  btn-block" (click)="cerrar(null)">Cerrar</button>
        </div>
    </div>
</div>